// TODO: it may be best to accompany this with a directive

/* this requires the use of ng-bind-html
 * <span ng-bind-html="$ctrl.origText | aptHighlight:$ctrl.stringToHighlight"
 * I originally intended to make this a directive or component but that turned out to be troublesome when using with the grid at least
 * so this turned out to be simpler and less code*/
export function aptHighlightTextFilter() {
  'ngInject';

  return function (text = '', searchText = '') {
    text = text.toString(); // ensure that our value is always a string

    if (searchText) {
      // escape backslashes in search text
      searchText = searchText.replace(/\\/g, '\\\\');
      text = text.replace(
        new RegExp(`(${searchText})`, 'gi'),
        '<mark>$1</mark>'
      );
    }
    return text;
  };
}
